export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./profit.vue?vue&type=template&id=9c507976"


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/profit.vue?vue&type=template&id=9c507976
// module id = Alum
// module chunks = 0